import { render } from "./RecordingsMain.vue?vue&type=template&id=39c939e6&scoped=true"
import script from "./RecordingsMain.vue?vue&type=script&lang=js"
export * from "./RecordingsMain.vue?vue&type=script&lang=js"

import "./RecordingsMain.vue?vue&type=style&index=0&id=39c939e6&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c939e6"]])

export default __exports__